import { useCallback, useMemo } from 'react';
import useLibTracker from 'personalization-lib/hooks/tracking/library/useLibTracker';
import { BUTTON_CLICK_ACTIONS, LIBRARY_USAGE_EVENTS } from 'personalization-lib/constants/tracking/libEvents';
const useButtonClickTracker = ({
  actionSource
}) => {
  const track = useLibTracker(LIBRARY_USAGE_EVENTS.BUTTON_CLICK);
  const createButtonClickTracker = useCallback(action => () => track({
    action,
    actionSource
  }), [track, actionSource]);
  return useMemo(() => ({
    backToPersonalization: createButtonClickTracker(BUTTON_CLICK_ACTIONS.backToPersonalization),
    variantSelect: createButtonClickTracker(BUTTON_CLICK_ACTIONS.variantSelect),
    preview: createButtonClickTracker(BUTTON_CLICK_ACTIONS.preview)
  }), [createButtonClickTracker]);
};
export default useButtonClickTracker;